var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"esign-multi-version"},[_c('EsignMultiVersion',{attrs:{"applyTrial":true,"useCache":false,"env":_vm.env}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }